<script setup lang="ts">
const props = defineProps({
  files: null
})

const { moveToArchive, permanentlyDelete } = useContextMenu()
const { downloadFiles } = useJobs()
const { addFilesToSidebar, removeFilesFromSidebar, sidebarFavoriteFiles } = useSidebar()
const { onFilesCut, onFilesCopied } = useClipboard()

const allPinned = computed(() => Object.keys(props.files).every(fileId => !!sidebarFavoriteFiles.value[fileId]))
const allArchived = computed(() => Object.values(props.files).every(file => file.getArchiveFolderFromPath()))
</script>

<template>
  <div>
    <menu-section>
      <!-- <dropdown-item
        v-if="!file.isFolder()"
        shortcut="␣"
        @click="peekFiles([file], 'collection-view')"
      >
        Quick View
      </dropdown-item>
      <dropdown-item
        v-if="file.isFolder()"
        shortcut="↵"
        @click="navigateToFolder(file)"
      >
        Open
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="↵"
        @click="navigateToFile(file)"
      >
        Open
      </dropdown-item>
      <dropdown-item
        v-if="file.isFolder()"
        shortcut="⌘↵"
        @click="openFolderInNewTab(file)"
      >
        Open in new tab
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="⌘↵"
        @click="openFileInNewTab(file)"
      >
        Open in new tab
      </dropdown-item>
      <menu-separator /> -->
      <dropdown-item
        shortcut="⌘X"
        @click="onFilesCut(files)"
      >
        Cut
      </dropdown-item>
      <dropdown-item
        shortcut="⌘C"
        @click="onFilesCopied(files)"
      >
        Copy
      </dropdown-item>
      <!-- <dropdown-item shortcut="⌘V">
        Paste
      </dropdown-item> -->
      <menu-separator />
      <dropdown-item
        v-if="allPinned"
        @click="removeFilesFromSidebar(files)"
      >
        Remove favorite
      </dropdown-item>
      <dropdown-item
        v-else
        @click="addFilesToSidebar(files)"
      >
        Add to favorites
      </dropdown-item>
      <menu-separator />
      <dropdown-item @click="downloadFiles(files)">
        Download
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item
        v-if="allArchived"
        @click="permanentlyDelete(files)"
      >
        <span class="delete-warning">Permanently Delete</span>
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="⌫"
        @click="moveToArchive(files)"
      >
        Move to Archive
      </dropdown-item>
    </menu-section>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.delete-warning
  @apply font-medium text-$global-red-primary

.icon-item
  @apply inline-flex gap-1 inline-center
  .icon
    @apply w-4 h-4 flex items-center justify-center
</style>
